import { Component, OnInit, inject } from '@angular/core'
import { Title } from '@angular/platform-browser'

@Component({
  selector: 'app-contactanos',
  templateUrl: './contactanos.component.html',
  standalone: false,
  styleUrls: ['./contactanos.component.css'],
})
export class ContactanosComponent implements OnInit {
  private _titleService = inject(Title)

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[])

  constructor() {}

  ngOnInit(): void {
    this._titleService.setTitle('Contáctenos - A2 Hacienda')
  }
}
